import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withCreateSet } from "src/modules/set/operations";
import { compose } from "src/helpers";

import CreateView from "./component";

const Create = (props) => {
    const { createSet } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await createSet(values);
        router.push("/set");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return <CreateView onFinish={onFinish} onFinishFailed={onFinishFailed} />;
};

export default compose(withCreateSet)(Create);
